export const SORT_KEY_EMAIL = "createdOn";
export const SORT_KEY_NAME = "firstName";
export const SORT_KEY_MODIFIED_ON = "modifiedOn";
export const SORT_KEY_MODIFIED_BY = "modifiedBy";
export const SORT_KEY_CREATED_BY = "createdBy";
